import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {TimePicker} from "../../../components/timepicker/timepicker";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {staffAttendAbsents} from "./attend-absents";

export const AdminsStaffAttendAddEditModal = (props: {
    active: boolean,
    closeHandler: any,
    edit:boolean,
    id:number,
    isExit:boolean,
    createdAt:string,
    onDone:()=>void,
    name:string,
}) => {
    const [time, setTime] = useState({
        time: [0, 0, 0],
        date: '2000-01-01',
    });
    const [isExit, setIsExit] = useState(false);
    const [isInside,setIsInside] = useState(false);
    const [staffId,setStaffId] = useState('');
    const ids = {
        staffId: useId(),
    };
    const [err,setErr] = useState({
        staffId:false,
    });
    const [list,setList] = useState<staffAttendAbsents[]>([]);
    const fetchList = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/attend/absents',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: staffAttendAbsents[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                setList(d.list === null ? [] : d.list);
            },
            () => {},
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        const isActive = props.active;
        const _date = props.createdAt;
        const _isExit = props.isExit;
        const isEdit = props.edit;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            if(isEdit){
                let d = _date.split(' ');
                let t = d[1].split(':');
                setTime({
                    time: [parseInt(t[0]), parseInt(t[1]),parseInt(t[2])],
                    date: d[0],
                });
                setIsExit(_isExit);
                setIsInside(!_isExit);
            } else {
                let todayIso = new Date().toISOString().split('T')[0];
                setTime({
                    time: [0, 0,0],
                    date: todayIso,
                });
                setIsExit(true);
                setIsInside(false);
                fetchList();
            }
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const _time = {...time};

    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal web-modal-bigger" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>{props.edit ? 'ویرایش حضور' : 'افزودن حضور'}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <label>تاریخ و ساعت:</label>
                                    <TimePicker
                                        lang={'fa'}
                                        hour={time.time[0]}
                                        minute={time.time[1]}
                                        setState={(h: number, m: number) => setTime(v => {
                                            let x = {...v};
                                            x.time[0] = h;
                                            x.time[1] = m;
                                            return x;
                                        })}
                                        title={''}
                                        locked={false}
                                        onSave={() => {
                                        }}
                                        date={time.date}  // gregorian
                                        setDate={(d: string) => setTime(v => {
                                            let x = {...v};
                                            x.date = d.split(" ")[0];
                                            return x;
                                        })}
                                        hasDate={true}
                                    />
                                    <div style={{height: 30}}/>
                                    <label htmlFor={ids.staffId} data-necessary="yes">انتخاب همکار:</label>
                                    <select id={ids.staffId}
                                           className={"form-control" + (err.staffId ? ' is-invalid' : '')}
                                           value={staffId}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setStaffId(t);
                                               setErr(v => {
                                                   let x = {...v};
                                                   x.staffId = false;
                                                   return x;
                                               });
                                           }}>
                                        <option value="">انتخاب کنید...</option>
                                        {
                                            list.map((d,i) =>
                                                <option key={"Bf4x" + i}
                                                    value={d.id.toString()}>{d.name} - ({d.inside ? 'داخل':'خارج'})</option>)
                                        }
                                    </select>
                                    <div className={"invalid-feedback" + (err.staffId ? ' d-block' : ' d-none')}>
                                        لطفا یک مورد را انتخاب کنید.
                                    </div>
                                    <div style={{height: 20}}/>
                                    <div style={{height: 30}}/>
                                    <label>نوع عملیات:</label>
                                    <button className={"techaran-radio-box" + (!isExit ? ' active':'')} onClick={()=>setIsExit(false)}>
                                        <div><i/></div>
                                        <span>ورود</span>
                                    </button>
                                    <button className={"techaran-radio-box" + (isExit ? ' active':'')} onClick={()=>setIsExit(true)}>
                                        <div><i/></div>
                                        <span>خروج</span>
                                    </button>
                                    <div style={{height: 20}}/>
                                    <label>وضعیت فعلی کارمند:</label>
                                    <button className={"techaran-radio-box" + (isInside ? ' active':'')} onClick={()=>setIsInside(true)}>
                                        <div><i/></div>
                                        <span>داخل آموزشگاه</span>
                                    </button>
                                    <button className={"techaran-radio-box" + (!isInside ? ' active':'')} onClick={()=>setIsInside(false)}>
                                        <div><i/></div>
                                        <span>خارج از آموزشگاه</span>
                                    </button>
                                    <div className="d-flex justify-content-end align-items-center" style={{gap:5,marginTop:30}}>
                                        <button className="cancel-button" onClick={props.closeHandler}>
                                            <b>انصراف</b>
                                        </button>
                                        <button className="btn-pay" onClick={saveChanges}>
                                            <b>ذخیره</b>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};